import { PlatformType } from '../types/project';

interface PlatformConfig {
  displayName: string;
  shortName: string;
  linkButtonTitle: string;
  generateButtonLabel: string;
}

export const PLATFORM_CONFIG: Record<PlatformType, PlatformConfig> = {
  [PlatformType.ServiceNow]: {
    displayName: 'ServiceNow',
    shortName: 'SN',
    linkButtonTitle: 'Link ServiceNow Site',
    generateButtonLabel: 'Generate SN Prototype',
  },
  [PlatformType.PowerApps]: {
    displayName: 'PowerApps',
    shortName: 'PA',
    linkButtonTitle: 'Link PowerApps Site',
    generateButtonLabel: 'Generate PA Prototype',
  },
  [PlatformType.TylerAppPlatform]: {
    displayName: 'TAP',
    shortName: 'TAP',
    linkButtonTitle: 'Link Tap Site',
    generateButtonLabel: 'Generate TAP Prototype',
  },
  [PlatformType.Salesforce]: {
    displayName: 'Salesforce',
    shortName: 'SF',
    linkButtonTitle: 'Link Salesforce Site',
    generateButtonLabel: 'Generate SF Prototype',
  },
};

export const getPlatformConfig = (platformType?: PlatformType): PlatformConfig => {
  return PLATFORM_CONFIG[platformType || PlatformType.TylerAppPlatform];
};

export const getPlatformDisplayName = (platformType?: PlatformType): string => {
  return getPlatformConfig(platformType).displayName;
};

export const getPlatformBadgeClass = (platformType?: PlatformType, isWeb?: boolean): string => {
  if (isWeb) return 'bg-utility-blue-50 border border-utility-blue-200 text-text-brand-primary';
  switch (platformType) {
    case PlatformType.ServiceNow:
      return 'bg-utility-purple-50 border border-utility-purple-200 text-utility-purple-700';
    case PlatformType.PowerApps:
      return 'bg-utility-orange-50 border border-utility-orange-200 text-utility-orange-700';
    case PlatformType.Salesforce:
      return 'bg-utility-pink-50 border border-utility-pink-200 text-utility-pink-700';
    case PlatformType.TylerAppPlatform:
      return 'bg-utility-success-50 border border-utility-success-200 text-utility-success-700';
    default:
      return 'bg-utility-blue-50 border border-utility-blue-200 text-text-brand-primary';
  }
};
